import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Dumbbell } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Personal Training', path: '/personal-training' },
    { name: 'Strength Programs', path: '/strength-programs' },
    { name: 'Fat Loss', path: '/fat-loss' },
    { name: 'Supplements', path: '/supplements' },
    { name: 'Memberships', path: '/memberships' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-[#39FF14]/10' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative">
              <Dumbbell className="w-8 h-8 text-[#39FF14] transition-transform group-hover:rotate-12" />
              <div className="absolute inset-0 blur-lg bg-[#39FF14]/30 animate-pulse" />
            </div>
            <span className="text-2xl font-bold text-white tracking-tight uppercase">
              Iron <span className="text-[#39FF14]">Crust</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium transition-all duration-300 rounded-full ${
                  location.pathname === link.path
                    ? 'text-black bg-[#39FF14] shadow-lg shadow-[#39FF14]/50'
                    : 'text-white hover:text-[#39FF14] hover:bg-white/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <a
            href="https://wa.me/918357015066?text=Hi, I want to join Iron Crust Gym!"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex items-center gap-2 px-6 py-3 bg-[#39FF14] text-black font-bold text-sm uppercase rounded-full hover:scale-105 hover:shadow-xl hover:shadow-[#39FF14]/50 transition-all duration-300"
          >
            Join Now
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-white hover:text-[#39FF14] transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`px-4 py-3 text-sm font-medium transition-all duration-300 rounded-lg ${
                  location.pathname === link.path
                    ? 'text-black bg-[#39FF14]'
                    : 'text-white bg-white/5 hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://wa.me/918357015066?text=Hi, I want to join Iron Crust Gym!"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 px-4 py-3 bg-[#39FF14] text-black font-bold text-sm text-center uppercase rounded-lg"
            >
              Join Now
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
